document.addEventListener('DOMContentLoaded', function () {

	if (document.querySelector('.js_noui_heart')) {

		var inputNumber = document.getElementById('heart-value');

		var heartSlider = document.querySelector('.js_noui_heart');
		var valuesForSlider = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; // 11 values

		var format = {
			to: function (value) {
				return valuesForSlider[Math.round(value)];
			},
			from: function (value) {
				return valuesForSlider.indexOf(Number(value));
			}
		};

		noUiSlider.create(heartSlider, {
			start: inputNumber.value,
			// A linear range from 0 to 10 (11 values)
			range: { min: 0, max: valuesForSlider.length - 1 },
			// steps of 1
			step: 1,
			tooltips: true,
			format: format,
			pips: { mode: 'steps', format: format },
			connect: 'lower',
		});



		var activePips = [null, null];

		heartSlider.noUiSlider.on('update', function (values, handle) {
			// Remove the active class from the current pip
			if (activePips[handle]) {
				activePips[handle].classList.remove('active-pip');
			}

			// Match the formatting for the pip
			var dataValue = Math.round(values[handle]);

			// Find the pip matching the value
			activePips[handle] = heartSlider.querySelector('.noUi-value[data-value="' + dataValue + '"]');

			// Add the active class
			if (activePips[handle]) {
				activePips[handle].classList.add('active-pip');
			}
		});


		var pips = heartSlider.querySelectorAll('.noUi-value');

		function clickOnPip() {
			var value = Number(this.getAttribute('data-value'));
			heartSlider.noUiSlider.set(value);
		}

		for (var i = 0; i < pips.length; i++) {

			// For this example. Do this in CSS!
			pips[i].style.cursor = 'pointer';
			pips[i].addEventListener('click', clickOnPip);
		}


		heartSlider.noUiSlider.on('update', function (values, handle) {
			var value = values[handle];
			inputNumber.value = value;
		});

	}
});